<style lang="less" scoped>
@import '../../../style/common/variable';
.imgTitleContent{position: relative;width: 800px;height: 170px;display: flex;border-bottom: solid rgb(173, 172, 172);border-width:1px;overflow: hidden;font-family: AlibabaPuHuiTi-Regular;margin-top: 18px;}
.boxWrap {width: 792px;height: 170px;border-width: 1px;margin-top:15px;margin-bottom:0;border-bottom:1px dashed #eee;cursor: pointer;}
.boxWrap:hover{.title{color: #13569e;}}
.picbox {position: absolute;left: 5px;width: 256px;height: 148px;overflow: hidden;border: 1px solid #eee;}
.picbox img{width: 256px;height: 148px;margin-right: 20px;transition: transform .5s;}
img:hover {transform: scale(1.4,1.4)}
.box{position: absolute;left: 280px;margin: 0px;}
p{margin: 0px;}
.title{width: 520px;font-size: 16px;font-weight: 600;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.content{font-size: 13px;margin-top: 14px;margin-bottom: 24px;margin-right: 12px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;}
.content{height: 48px;line-height: 16px; overflow:hidden;}
.content::after{content: ' ... ';}
.time{font-size: 12px;margin-top: 14px;}
.address{font-size: 12px;margin-top: 5px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
/* 移动端适配 */
@media screen and (max-width: @max-screen) {
  .boxWrap {width: 100vw; display: flex; justify-content: space-around;
    .picbox{width: 1.5rem; position: static;
      img{width: 1.5rem}
    }
    .box{width: calc(95vw - 1.5rem); position: static;
      .title{width: calc(95vw - 1.5rem);;}
    }
  }
}
</style>

<!-- 何宽 2021.6.11
     该组件使用场景：以列表形式纵向展示 图片、标题、内容等信息，点击该信息，将整个对象传递给父组件-->
<template>
  <div class="imgTitleContent" @click="handleClick(imgTitleContentItem)">
    <div class="boxWrap">
      <div class="picbox">
        <img :src="imgTitleContentItem.pic" />
      </div>
      <div class="box">
        <p class="title"> {{ imgTitleContentItem.title }} </p>
        <p class="content"> {{ imgTitleContentItem.introduce }} </p>
        <p class="time"> {{ imgTitleContentItem.release}}：{{ imgTitleContentItem.time * 1000 | formatDate() }} </p>
        <p class="address"> {{ imgTitleContentItem.description}}：{{ imgTitleContentItem.value }} </p>
      </div>
    </div>
  </div>
</template>

<script>
import filters from '../method/filter.js'
export default {
  props: ['imgTitleContentItem'],
  mixins: [filters],
  data()
  {
    return {}
  },
  updated()
  {
    var oList = document.querySelectorAll('.content')
    var alltableArray = Array.prototype.slice.call(oList)
    alltableArray.forEach(function(item)
    {
      var oHeight = item.height
      if ((oHeight / 15) > 2)
        item.className = 'content'
    })
  },
  // 点击图片、标题、内容，将 被点击的整个信息对象 传递给父组件
  methods: {
    handleClick(item)
    {
      this.$emit('handleClick', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/ImgTitleContent.vue